import axios from "axios";
import { Auth0Client } from "@auth0/auth0-spa-js";
import { apiConfig } from "../../config";
import { SubscriptionReceipt } from "../../types/billing";

class ReceiptClient {
  private auth0Client: Auth0Client;

  constructor(auth0Client: Auth0Client) {
    this.auth0Client = auth0Client;
  }

  private async getAuthHeaders() {
    const token = await this.auth0Client.getTokenSilently();
    return {
      Authorization: `Bearer ${token}`,
    };
  }

  async getReceipts(orgId: string): Promise<SubscriptionReceipt[]> {
    const headers = await this.getAuthHeaders();
    const response = await axios.get(
      `${apiConfig.providerServiceBase}/v2/api/receipts/organization/${orgId}`,
      { headers },
    );
    return response.data;
  }

  async getReceipt(receiptId: string): Promise<SubscriptionReceipt> {
    const headers = await this.getAuthHeaders();
    const response = await axios.get(
      `${apiConfig.providerServiceBase}/v2/api/receipts/${receiptId}`,
      { headers },
    );
    return response.data;
  }

  async getReceiptByLedgerId(ledgerId: string): Promise<SubscriptionReceipt> {
    const headers = await this.getAuthHeaders();
    const response = await axios.get(
      `${apiConfig.providerServiceBase}/v2/api/receipts/ledger/${ledgerId}`,
      { headers },
    );
    return response.data;
  }
}

export default ReceiptClient;
